import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { recordPageHit } from '../services/api/pageAnalytics';

// Public / pre-auth routes carry no v1→v2 migration signal — skip the request entirely (the server
// ignores them too, but no reason to send it).
const PUBLIC_PREFIXES = [
  '/login', '/register', '/forgot-password', '/reset-password', '/privacy-policy',
  '/terms-of-use', '/account-deletion', '/privacy-consent', '/campaign-access', '/pmi/registration',
];

// Records one page view per authenticated route change (deduped on consecutive same-path). Renders
// nothing; mounted once inside the Router so useLocation sees every navigation.
const PageAnalyticsTracker = () => {
  const location = useLocation();
  const lastPath = useRef('');

  useEffect(() => {
    const path = location.pathname || '';
    if (!path || path === lastPath.current) return;
    lastPath.current = path;
    const token = localStorage.getItem('token');
    if (!token) return; // only track authenticated navigation
    if (path === '/' || PUBLIC_PREFIXES.some((p) => path.startsWith(p))) return;
    recordPageHit(path);
  }, [location.pathname]);

  return null;
};

export default PageAnalyticsTracker;
